"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.tersible = exports.Tersiblized = void 0;
var tersify_js_1 = require("./tersify.js");
/**
 * Create a Tersible mixin class
 * NOTE: `this` in `tersify` is not typed.
 * Currently this seems to be a limitation on optional generic.
 * I can't do <T, C extends ...> because user need to specify the constructor,
 * and I can't do <T = any, C extends ... = ?> to make the generic optional.
 * I would like to do <T = any, C extends ...> so that user can do `Tersible(...)` and `Tersible<Foo>(...)`
 * @param Base Base class
 * @param tersify the tersify function
 */
function Tersiblized(Base, tersify) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _super.apply(this, args) || this;
        }
        Object.defineProperty(class_1.prototype, "tersify", {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (options) {
                return tersify.call(this, options);
            }
        });
        return class_1;
    }(Base));
}
exports.Tersiblized = Tersiblized;
/**
 * Inject `tersify()` to subject.
 * NOTE: this does inject directly to `subject`.
 * It is not ideal to modify the argument,
 * but it cannot be done otherwise.
 * How can I "clone" a function or class?
 */
function tersible(subject, tersify) {
    var tersifyFn = tersify === undefined ?
        tersify_js_1.defaultTersify :
        typeof tersify === 'string' ?
            function () { return tersify; } :
            tersify;
    Object.defineProperty(subject, 'tersify', {
        value: tersifyFn,
        enumerable: false,
        writable: false
    });
    return subject;
}
exports.tersible = tersible;
//# sourceMappingURL=tersible.js.map